import type { ReactNode } from 'react'

import type { MapActions } from './mapView'
import { StatementMenu } from './StatementMenu'
import type { StatementView } from './types'

interface StatementButtonProps {
  view: StatementView
  choosing: boolean
  // A pile of loose pages is not a statement, so it cannot be deleted.
  deletable?: boolean
  title: string
  className: string
  actions: MapActions
  children: ReactNode
}

// A statement on the map opens on a click, or takes the pages in hand while some are held.
export const StatementButton = ({
  view,
  choosing,
  deletable = true,
  title,
  className,
  actions,
  children,
}: StatementButtonProps) => (
  <StatementMenu
    onEditRange={() => actions.onEditRange(view)}
    onDelete={deletable ? () => actions.onDelete(view) : undefined}
  >
    <button
      type="button"
      data-statement-id={view.statement.id}
      data-drop-target
      onClick={() => (choosing ? actions.onPutIn(view) : actions.onOpen(view))}
      className={className}
      title={title}
    >
      {children}
    </button>
  </StatementMenu>
)
